import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from '../_atoms';
import { fillPicturesStore } from '../redux/reducers/picturesReducer';
import '../styles/card_item.scss';
import { TITLES } from './books';

export const CardItem = ({ item, deleteFotobook, massDeliverPrice }) => {
  const dispatch = useDispatch();
  const [popupInfo, setPopupInfo] = useState(null);
  const cover = item.coverImages[0] ? item.coverImages[0] : item.images[0];
  const productTypes = useSelector(state => state.common.productTypes);
  const product = productTypes[item.productType].find(({ id }) => id === item.productTypeId);
  const size = product && item.size ? product.sizes_obj[item.size] : '-';
  const type = product && item.type ? product.types_obj[item.type] : '';
  const orientString = product && item.orientation ? product.orientations_obj[item.orientation] || '' : '';
  const orientation = orientString.length >= 8 ? `${orientString.slice(0, 8)}.` : orientString;
  const price = massDeliverPrice?.[item?.id] || 0;
  const sizeRow = item.productTypeId === 'gift-cert-RU' ? `Номинал ${size}р.` : `${size} ${type} ${orientation}`;
  const priceRow =
    item.productTypeId === 'gift-cert-RU'
      ? `${item.numberOfCopies}шт. = ${price}р.`
      : `${item.images.reduce((sum, i) => sum + i.numberOfCopies, 0)} фото ${
          item.numberOfCopies > 1 ? `* ${item.numberOfCopies}` : ''
        } = ${price}р.`;

  const onEditClick = () => {
    dispatch(fillPicturesStore({ images: item.images, coverImages: item.coverImages }));
  };

  const onDelete = () => {
    deleteFotobook(popupInfo.event, popupInfo.item);
    setPopupInfo(null);
  };

  const query = {
    orientation: item.orientation,
    size: item.size,
    type: item.type,
    basketItemId: item.id,
    productTypeId: item.productTypeId,
    shilda: item.shilda,
    cover: item.cover,
    wishes: item.wishes,
    min: item.min,
    max: item.max,
    numberOfCopies: item.numberOfCopies,
    comment: item.comment,
    id: item.productId,
  };

  return (
    <div className="card-item">
      <img
        className="card-item-image"
        src={cover.url}
        alt="Обложка"
        style={{ transform: `rotate(${cover.rotateAngle || 0}deg)` }}
      />
      <p className="card-item-price">
        {product?.type === 'postcards' ? `Открытки (${product?.name || '-'})` : product?.name || '-'}
      </p>
      <p className="card-item-text">{sizeRow}</p>
      <p className="card-item-text">{priceRow}</p>
      <Link
        className="Btn editBtn"
        onClick={onEditClick}
        to={{ pathname: `products/${item.productType}/${item.productTypeId}`, query }}
      >
        <Button className="card-button">Изменить</Button>
      </Link>
      <Button className="card-button" onClick={e => setPopupInfo({ event: e, item })}>
        Удалить
      </Button>
      {!!popupInfo?.item && (
        <div className="showLoader">
          <div className="answerFromServer">
            <h3>Удалить товар из корзины?</h3>
            <div className="showLoader__buttons">
              <Button onClick={onDelete}>Удалить</Button>
              <Button onClick={() => setPopupInfo(null)}>Отмена</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
